import generatedSiteConfig from "./generated/site-config.json";

export const siteConfig = {
  studioName: generatedSiteConfig.displayName,
  domain: generatedSiteConfig.domain,
  baseUrl: generatedSiteConfig.baseUrl,
  contactEmail: generatedSiteConfig.contactEmail,
  seo: generatedSiteConfig.seo,
  ogImage: generatedSiteConfig.ogImage,
  ads: generatedSiteConfig.ads,
  assets: generatedSiteConfig.assets,
  nav: [
    { id: "games", href: "/#games" },
    { id: "studio", href: "/#studio" }
  ],
  socials: generatedSiteConfig.socials.map((href) => ({
    id: href,
    label: new URL(href).hostname.replace(/^www\./, ""),
    href
  })),
  storeLinks: [
    { label: "Privacy Policy", href: "/privacy" },
    { label: "Terms", href: "/terms" },
    { label: "Support", href: "/support" }
  ]
} as const;
